export default "../images/stackloans-partners-with-Upgrade_PORTAL_US.png?399addfff142a9129e1d30d09622ba11";